module.exports = __webpack_public_path__ + "static/media/fishin-carava-feature-1.0cb569f7.png";